import { useQuery } from "@tanstack/react-query";
import { AxiosRequestConfig } from "axios";
import { instanceConexao } from "services/axiosServices";

/**
 * @function fetchTipoSugestao
 * @returns {Promise<any>} - retorna confirmação da request.
 */
export const fetchTipoSugestao = (
  authToken: string,
  enabled?: boolean
): any => {
  const fetch = async (): Promise<any> => {
    const url = "api/Sugestao";
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    const response = await instanceConexao.get(url, config);
    return response?.data;
  };

  const query = useQuery({
    queryFn: async () => fetch(),
    queryKey: ["fetch-tipo-sugestao"],
    enabled: enabled === undefined ? true : enabled,
    refetchOnWindowFocus: false,
  });

  return query;
};

export const getTipoSugestao = async (authToken: string) => {
  const url = "api/Sugestao";
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.get(url, config);
  return response?.data;
};
